import { render } from "./IconDisconnectColor.vue?vue&type=template&id=20b33372&scoped=true"
import script from "./IconDisconnectColor.vue?vue&type=script&lang=js"
export * from "./IconDisconnectColor.vue?vue&type=script&lang=js"

import "./IconDisconnectColor.vue?vue&type=style&index=0&id=20b33372&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b33372"]])

export default __exports__